module.exports = __webpack_public_path__ + "img/BannerNew.ba455c27.png";